import { ConfettiPresenter } from '@/presentation/presenters/util/confettiPresenter'

export function useConfettiPresenter(presenter: ConfettiPresenter = new ConfettiPresenter()) {
  return {
    runConfetti: presenter.runConfetti.bind(presenter)
  }
}
